import type { MouseEvent, Ref } from 'react'
import type { ResizeHandleAxis } from 'react-resizable'
import * as S from './ResizeControls.styled'

type ResizeHandleElementProps = {
  position?: ResizeHandleAxis
  selected?: boolean
  innerRef?: Ref<HTMLDivElement>
  itemLocked?: boolean
  onMouseDown?: (e: MouseEvent<HTMLDivElement>) => void
  itemId?: string
}

/**
 * A functional handle of an editor text box or rule: the DraggableCore
 * anchor the overlay's corner and pill chrome forward their mousedown to.
 */
export const ResizeHandleElement = ({
  position,
  selected,
  innerRef,
  itemLocked,
  onMouseDown,
  itemId,
}: ResizeHandleElementProps) => {
  // Preventing the default keeps the browser's mousedown focus move from
  // blur-exiting a mid-edit editing session; DraggableCore drags without it.
  const handleMouseDown = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault()
    onMouseDown?.(e)
  }

  return (
    <S.ResizeHandle
      className="no-drag"
      ref={innerRef}
      position={position}
      selected={selected}
      onMouseDown={handleMouseDown}
      $itemLocked={itemLocked}
      data-resize-handle={itemId}
      data-resize-placement={position}
    />
  )
}

ResizeHandleElement.displayName = 'ResizeHandleElement'
